'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _seekSeekClassificationsHierarchy = require('@seek/seek-classifications-hierarchy');

var _seekSeekClassificationsHierarchy2 = _interopRequireDefault(_seekSeekClassificationsHierarchy);

var descriptionsById = {};

_seekSeekClassificationsHierarchy2['default'].forEach(function (classification) {
  descriptionsById[classification.id] = classification.description;

  classification.subClassifications.forEach(function (subClassification) {
    descriptionsById[subClassification.id] = subClassification.description;
  });
});

exports['default'] = function (id) {
  return descriptionsById[id] || null;
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/hierarchy/class-description-by-id.js
 ** module id = 554
 ** module chunks = 0
 **/